<template>
  <div class="aboutus container">
    <div class="banner container">
      <div class="banner1"></div>
    </div>
    <!--    信念铸就成功-->
    <!-- <div class="wholesale_programme_title1">
      <div class="wholesale_programme_title_text1 wholesale_programme_title_text2">
        信念铸就成功
        <img src="../assets/img/title3@2x.png" alt=""/>
      </div>
      <div class="zhexian"></div>
    </div>

    <div class="success_box">
      <div v-for="(item,index) in successList" :key="index" class="success_con">
        <img :src="item.image" alt="">
        <div>{{item.title}}</div>
        <p>{{item.content}}</p>
      </div>
    </div> -->

    <div class="main container3">
      <div class="main-title">杭州禾平数据技术有限公司</div>
      <div class="main-line"></div>
      <div class="main-con1">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;杭州禾平数据技术有限公司是一家位于中国浙江省杭州市的高科技企业，成立于2017年。公司专注于提供基于大数据、人工智能和云计算技术的解决方案和服务，旨在帮助客户提高效率、降低成本、优化运营。
      </div>
      <div class="main-con2">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;禾平数据技术有限公司的业务范围涵盖了多个行业领域，包括金融、医疗、零售、物流、教育等。公司的核心产品和服务包括数据分析、数据挖掘、大数据平台搭建、人工智能应用开发、云计算解决方案等。
      </div>
      <div class="main-con3">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;禾平数据技术有限公司拥有一支技术实力雄厚的团队，其中包括了多名具有丰富经验和高水平的数据科学家、算法工程师、软件工程师等。公司秉承“创新、务实、合作、共赢”的理念，致力于为客户提供高质量、高效率的解决方案和服务。
      </div>
    </div>
    <div class="pic container">
      <div class="pic-main container1">
        <div class="pic-top container2">
          <img src="@/assets/img/zs_1@2x.png" class="pic-top-img" alt="" />
          <img src="@/assets/img/zs_2@2x.png" class="pic-top-img" alt="" />
        </div>
        <div class="pic-bom conatiner2">
          <img :src="item.img" alt="" v-for="item in list" :key="item.id" class="pic-bom-img" />
        </div>
      </div>
    </div>
    <!-- <div class="map container1"></div>
    <div class="map-intro container1">
      <div class="map-left">
        <img src="@/assets/img/dizhi@2x.png" alt=""/>
        <div class="left-title">浙江省杭州市西湖区奔腾科技园5号楼513室</div>
      </div>
      <div class="map-right">
        <img src="@/assets/img/zuoji@2x.png" alt=""/>
        <div class="right-title">18958058058</div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      successList: [
        {
          image: require('../assets/img/yj.png'),
          title: '愿景',
          content: '企业愿景企业愿景企业愿景企业愿景企业愿景企业愿景'
        },
        {
          image: require('../assets/img/sm.png'),
          title: '使命',
          content: '企业愿景企业愿景企业愿景企业愿景企业愿景企业愿景'
        },
        {
          image: require('../assets/img/jzg.png'),
          title: '价值观',
          content: '企业愿景企业愿景企业愿景企业愿景企业愿景企业愿景'
        }
      ],
      list: [
        {
          id: 1,
          img: require('../assets/img/zs_3@2x.png')
        },
        {
          id: 2,
          img: require('../assets/img/zs_4@2x.png')
        },
        {
          id: 3,
          img: require('../assets/img/zs_5@2x.png')
        },
        {
          id: 4,
          img: require('../assets/img/zs_6@2x.png')
        },
        {
          id: 5,
          img: require('../assets/img/zs_7@2x.png')
        },
        {
          id: 6,
          img: require('../assets/img/zs_8@2x.png')
        },
        {
          id: 7,
          img: require('../assets/img/zs_9@2x.png')
        },
        {
          id: 8,
          img: require('../assets/img/zs_10@2x.png')
        },
        {
          id: 9,
          img: require('../assets/img/zs_11@2x.png')
        },
        {
          id: 10,
          img: require('../assets/img/zs_12@2x.png')
        },
        {
          id: 11,
          img: require('../assets/img/zs_13@2x.png')
        },
        {
          id: 12,
          img: require('../assets/img/zs_14@2x.png')
        },
        {
          id: 13,
          img: require('../assets/img/zs_15@2x.png')
        },
        {
          id: 14,
          img: require('../assets/img/zs_16@2x.png')
        },
        {
          id: 15,
          img: require('../assets/img/zs_17@2x.png')
        },
        {
          id: 16,
          img: require('../assets/img/zs_18@2x.png')
        },
        {
          id: 17,
          img: require('../assets/img/zs_19@2x.png')
        },
        {
          id: 18,
          img: require('../assets/img/zs_20@2x.png')
        },
        {
          id: 19
          // img: require("..//assets/img/zs_20@2x.png"),
        },
        {
          id: 20
          // img: require("../assets/img/zs_20@2x.png"),
        }
      ]
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  margin: 0 auto;
}

.container1 {
  width: 1200px;
  margin: 0 auto;
}

.conatiner2 {
  width: 1200px;
  margin: 0 auto;
}

.container3 {
  width: 1200px;
  margin: 0 auto;
}

.banner {
  height: 550px;
  margin-bottom: 73px;
}

.banner1 {
  width: 100%;
  background: url('../assets/img/banner_gywm.png') no-repeat center center;
  background-size: cover;
  min-height: 550px;
  height: 550px;
}

.main {
  margin-bottom: 50px;
}

.main-title {
  height: 28px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
  line-height: 28px;
  margin-bottom: 30px;
}

.main-line {
  width: 60px;
  height: 4px;
  background: #1958c4;
  margin-top: 13px;
  margin-bottom: 31px;
}

.main-con1,
.main-con2,
.main-con3 {
  width: 1200px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 32px;

  margin-bottom: 20px;
}

.pic {
  background-color: #f2f6fb;
  overflow: hidden;
  border-top-right-radius: 100px;
  border-top-left-radius: 100px;
}

.pic-top {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.pic-top-img {
  width: 604px;
  height: 394px;
  transition: 0.5s;
}

.pic-top-img:hover {
  transform: scale(1.05);
}

.pic-bom {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 50px;
}

.pic-bom-img {
  width: 234px;
  height: 306px;
  transition: 0.5s;
  /* margin-bottom: 20px; */
}

.pic-bom-img:hover {
  transform: scale(1.1);
}

.pic-bom-img:last-child {
  opacity: 0;
}

.pic-bom-img:nth-last-child(2) {
  opacity: 0;
}

.map {
  margin: 50px auto;
  background: url('../assets/img/map@2x.png') center center no-repeat;
  background-size: 100%;
  height: 600px;
}

.map-intro {
  width: 900px;
  display: flex;
  justify-content: space-around;
  margin-bottom: 50px;
}

.map-left,
.map-right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.map-left img {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

.map-right img {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

.left-title,
.right-title {
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
}

.wholesale_programme_title_text img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -15px;
}

.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 16px auto 0;
}

.wholesale_programme_title1 {
  width: 1200px;
  margin: 0 auto;
}

.wholesale_programme_title_text1 {
  width: 240px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  z-index: 99;
}

.wholesale_programme_title_text1 img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -5px;
  z-index: -1;
}

.wholesale_programme_title_text2 {
  width: 205px;
}

.success_box {
  width: 1200px;
  margin: 50px auto 108px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  box-sizing: border-box;
}

.success_box img {
  width: 160px;
  height: 160px;
}

.success_con div {
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin: 24px 0;
}

.success_con {
  width: 376px;
  height: 400px;
  background: #f2f6fb;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 49px 56px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 26px;
}

.success_con:hover {
  scale: 1.02;
  border-radius: 4px;
  background: #ffffff;
  box-shadow: 0px 6px 16px 5px rgba(0, 0, 0, 0.14);
  cursor: pointer;
}
</style>
